module.exports = __webpack_public_path__ + "img/time.77af3108.svg";